import {CSSProperties, FC} from 'react';


export interface IIconTwitterProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTwitter: FC<IIconTwitterProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.626 0 12 0Zm5.48 9.356c.004.118.007.237.007.356 0 3.64-2.77 7.837-7.837 7.837a7.796 7.796 0 0 1-4.222-1.237 5.526 5.526 0 0 0 4.078-1.141 2.757 2.757 0 0 1-2.573-1.913 2.743 2.743 0 0 0 1.244-.047 2.755 2.755 0 0 1-2.21-2.7v-.035c.372.206.796.33 1.248.344a2.752 2.752 0 0 1-.852-3.677 7.82 7.82 0 0 0 5.677 2.878 2.755 2.755 0 0 1 4.694-2.512 5.525 5.525 0 0 0 1.748-.669 2.765 2.765 0 0 1-1.21 1.524 5.494 5.494 0 0 0 1.58-.434 5.599 5.599 0 0 1-1.373 1.426Z" clipRule="evenodd" />
        </svg>
    );
};
